import { useSaveGeneralDataDraftMutation } from '../../../../redux/api/questionnaire/questionnaire-api';
import useDraft from './useDraft';

export const useGeneralDataDraft = () => {
  return useDraft(
    questionnaire => questionnaire.generalDataForm,
    useSaveGeneralDataDraftMutation
  );
};
